"use client";

import React from "react";
import Link from "next/link";
import { ChevronRightCircle } from "lucide-react";
import MaxWidthContainer from "./max-width-container";
import CustomLabel from "../ui/custom-label";
import { api } from "@/trpc/react";
import TripSliderLoader from "./trip-slider-loader";
import TripSlider from "./trip-slider";
import { type AdventureType } from "@prisma/client";
import { cn } from "@/lib/utils";

const UpcomingTripOrTrek = ({
  adventuretype,
  className,
  lable,
  navigation,
  isFeatured,
  href,
}: {
  className?: string;
  adventuretype: AdventureType;
  lable: string;
  navigation: string;
  isFeatured?: boolean;
  href?: string;
}) => {
  const { data, isLoading } = api.trips.get_upcoming_trips_or_treks.useQuery({
    adventuretype,
    isFeatured,
  });
  if (isLoading) return <TripSliderLoader title={lable} />;

  if (!data || data.length < 1) return null;
  return (
    <section
      className={cn("relative overflow-hidden py-8 md:py-12", className)}
    >
      <MaxWidthContainer className="relative space-y-5">
        <div className="flex flex-nowrap items-start justify-between">
          <CustomLabel label={lable} />
          {href && (
            <Link
              href={href}
              className="secondary-btn px-3 py-1.5 sm:px-4 sm:py-2 secondary-btn-animation flex w-fit flex-nowrap items-center gap-2"
            >
              Show All <ChevronRightCircle className="size-4 lg:size-5" />
            </Link>
          )}
        </div>
        <TripSlider
          navigationBtn={navigation}
          data={data}
          isTrips={adventuretype === "Trip" ? true : false}
        />
      </MaxWidthContainer>
    </section>
  );
};

export default UpcomingTripOrTrek;
